import * as React from "react"
import logo from '@/assets/easibuy_logo_color.png'
import {
  BookOpen,
  Bot,
  Building2,
  Command,
  Frame,
  Handshake,
  Inbox,
  LifeBuoy,
  Map,
  PieChart,
  Send,
  Settings2,
  SquareTerminal,
  UserIcon,
  UsersIcon,
} from "lucide-react"
import { usePage } from "@inertiajs/react"
import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import type { User } from "@/types/serializers"

interface Props {
  current_user: User
  counts: {
    inbox: number
    drafts: number
    expiring: number
  }
}

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { url } = usePage()
  const { current_user, counts } = usePage().props

  const data = {
    navMain: [
      {
        title: "Inbox",
        url: "/inbox",
        icon: Inbox,
        badge: counts.inbox,
        isActive: url === "/inbox" || url === "/",
      },
      {
        title: "Deals",
        url: "/deals",
        icon: Handshake,
        items: [
          {
            title: "Active",
            url: "/deals",
            isActive:  url === "/deals"
          },
          {
            title: "Drafts",
            url: "/deals/drafts",
            isActive: url === "/deals/drafts",
            badge: counts.drafts
          },
          {
            title: "Expiring",
            url: "/deals/expiring",
            isActive: url === "/deals/expiring",
            badge: counts.expiring
          },
          {
            title: "Archived",
            url: "/deals/archived",
            isActive: url === "/deals/archived",
          },
        ],
      },
      {
        title: "Accounts",
        url: "/buyers",
        icon: Building2,
        items: [
          {
            title: "Buyers",
            url: "/buyers",
            isActive: url.startsWith("/buyers"),
          },
          {
            title: "Suppliers",
            url: "/suppliers",
            isActive: url.startsWith("/suppliers"),
          },
          {
            title: "Agents",
            url: "/agents",
            isActive: url.startsWith("/agents"),
          },
        ],
      },
      {
        title: "Teams",
        url: "/teams",
        icon: UsersIcon,
        isActive: url.startsWith("/teams"),
      },
      {
        title: "Users",
        url: "/users",
        icon: UserIcon,
        isActive: url.startsWith("/users"),
      },
    ],
  }

  return (
    <Sidebar variant="inset" {...props}>
      <SidebarHeader className="pt-0">
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <a href="/">
                <div className="flex items-center">
                  <img
                    src={logo}
                    alt="Logo"
                    className="h-7"
                  />
                </div>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.navMain} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={current_user} />
      </SidebarFooter>
    </Sidebar>
  )
}
